import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ModalInterface } from "app/interface/modal";
import { BehaviorSubject } from 'rxjs';
import { B2bService } from '@core/services/b2b.service';
import { PartnerDocument } from '@shared/models/partner-document';
import { CommonService } from '@core/services/common.service';
import { SortEvent, SortDirection } from '@aposin/ng-aquila/table';

@Component({
    selector: 'app-partner-document-part',
    templateUrl: './partner-document-part.component.html',
    styleUrls: ['./partner-document-part.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PartnerDocumentPartComponent implements OnInit, AfterViewInit, ModalInterface {

    @ViewChild('PartList') modalTemplateRef: TemplateRef<any>;
    initiator: BehaviorSubject<boolean> = new BehaviorSubject(false);
    modalDialogRef: NxModalRef<any, any>;
    confirm: BehaviorSubject<SubmitEvent> = new BehaviorSubject(null);

    public partnerDocument: PartnerDocument;

    public partnerDocumentList: PartnerDocument[] = [];

    // table
    public page = 1;
    public elementsPerPage = 10;
    public partnerDocumentListPage: PartnerDocument[] = [];
    constructor(
        private dialogService: NxDialogService,
        private b2b: B2bService,
        private commonService: CommonService
    ) {
    }

    openModal(): void {
        this.modalDialogRef = this.dialogService.open(this.modalTemplateRef, {
            showCloseIcon: true,
            width: '1200px',
            maxWidth: '1200px'
        });
        this.b2b.getPartnerDocumentPartList(this.partnerDocument.dms2numPz, this.partnerDocument.dms2docId)
            .subscribe(result => {
                this.partnerDocumentList = result;
                this.sortTable(new SortEvent('createTs', 'desc'));
            });
    }

    closeModal(): void {
        this.modalDialogRef.close();
    }

    ngAfterViewInit(): void {
        this.initiator.next(true);
    }

    ngOnInit(): void {
    }

    inputData(inputData?: any): void {
        if (inputData['partnerDocument']) {
            this.partnerDocument = inputData['partnerDocument'];
        }
    }

    documentDownloadUrl(policyNumber: string, itemId: string) {
        return this.commonService.getServiceUrl(`partner-document/content/${policyNumber}/${itemId}`);
    }

    updatePage() {
        const indexMin = (this.page - 1) * this.elementsPerPage;
        const indexMax = indexMin + this.elementsPerPage;
        this.partnerDocumentListPage =
            this.partnerDocumentList.filter(
                (x, index) => index >= indexMin && index < indexMax,
            );
    }

    prevPage() {
        this.page--;
        this.updatePage();
    }

    nextPage() {
        this.page++;
        this.updatePage();
    }

    goToPage(n: number) {
        this.page = n;
        this.updatePage();
    }

    sortTable(sort: SortEvent) {
        this.partnerDocumentList = this.partnerDocumentList.sort(
            (a: { [key: string]: any; }, b: { [key: string]: any; }) => {
                if (sort.active in a && sort.active in b) {
                    if (a[sort.active] === null) {
                        a[sort.active] = '';
                    }
                    if (b[sort.active] === null) {
                        b[sort.active] = '';
                    }
                    return this.compare(
                        a[sort.active],
                        b[sort.active],
                        sort.direction,
                    );
                }
                return 0;
            },
        );

        this.updatePage();
    }

    compare(
        a: number | string | Date,
        b: number | string | Date,
        direction: SortDirection,
    ) {
        if (a < b) {
            return direction === 'asc' ? -1 : 1;
        } else if (a > b) {
            return direction === 'asc' ? 1 : -1;
        }
        return 0;
    }

}
